/** Shared monospace styling so registration plates render at a consistent size. */
// `whitespace-nowrap`: a registration is one token — breaking "BL123-AB" across two lines in a
// narrow table column makes it unreadable, and every table that shows one already pins its header.
export const PLATE_NUMBER_CLASS_NAME =
  "font-mono text-[13px] leading-tight tabular-nums tracking-wide whitespace-nowrap";

/** For Leaflet popup HTML (no Tailwind in template strings). */
export const PLATE_NUMBER_INLINE_STYLE =
  "font-family: 'JetBrains Mono', ui-monospace, SFMono-Regular, monospace; font-size: 13px; line-height: 1.25; font-variant-numeric: tabular-nums; letter-spacing: 0.02em; white-space: nowrap;";

export function formatPlateNumberValue(plate?: string | null): string {
  const trimmed = plate?.trim();
  if (!trimmed || trimmed === "-") return "—";
  return trimmed;
}

export function hasDisplayablePlate(plate?: string | null): boolean {
  const trimmed = plate?.trim();
  return Boolean(trimmed && trimmed !== "-");
}
